module.exports = __webpack_public_path__ + "static/media/success.4e7e66ce.png";